import React, {useEffect, useRef} from 'react'
import {createComponent} from '@lit/react'
import {ErrorModal as ErrorModalElement} from './error-modal'

type Props = {
  title: string
}

export function ChromelessErrorModal({title}: Props) {
  const modalRef = useRef<ErrorModalElement | null>(null)

  useEffect(() => {
    modalRef.current?.show()
  }, [])

  return <ErrorModalReact ref={modalRef} title={title} />
}

const ErrorModalReact = createComponent({
  react: React,
  tagName: 'error-modal',
  elementClass: ErrorModalElement,
})
